module.exports = __webpack_public_path__ + "static/main_text_en-052cecca221e329408513141553c5962.svg";